import { Theme } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles({ spacing, palette }: Theme) {
    return {
        submitIcon: {},
        submitButton: {
            marginRight: spacing(1),
            marginTop: `-${spacing(1)}px`,
        },
        almeInputBox: {
            marginLeft: spacing(1),
            marginRight: spacing(1),
            marginBottom: 0,
        },
        textField: {
            color: palette.text.primary,
        },
        inputLabel: {},
    };
}